"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFeatureArea = void 0;
/**
 * Base/Parent class that houses shared functionality/state for feature areas child classes
 */
var BaseFeatureArea = /** @class */ (function () {
    /**
     * BaseFeatureArea class constructor used by child classes to set appPermissions {@link EntityPermissionMap}
     * @param accessControl data received from BE on init {@link AccessControl}
     * @param altEvalFn optional logic to run in BaseFeatureArea.evalPermission {@link EvalPermissionFallback}
     */
    function BaseFeatureArea(appPermissions, altEvalFn) {
        this.altEvalFn = null;
        if (this.appPermissions === undefined) {
            this.appPermissions = appPermissions;
        }
        if (altEvalFn && this.altEvalFn === null) {
            this.altEvalFn = altEvalFn;
        }
    }
    /**
     * Evaluates if a user has the current permission
     * Runs altEvalFun {@link AltPermissionEval} if it's provided and doesn't explicitly return `null`
     * @param currentPermission current permission for evaluation
     * @param entityOptions optional object (Guide, Page, etc.) and other options for when it's necessary to check
     * @returns the return of permission evaluation as boolean
     */
    BaseFeatureArea.prototype.evalPermission = function (currentPermission, entityOptions) {
        var altPermission = this.altEvalFn && this.altEvalFn(currentPermission, entityOptions);
        if (altPermission !== null) {
            // altEvalFn() should return boolean, but this comes from outside lib, so we force to boolean
            return Boolean(altPermission);
        }
        var source = this.getSourceOrTarget(currentPermission, 'source', entityOptions === null || entityOptions === void 0 ? void 0 : entityOptions.field);
        var target = this.getSourceOrTarget(currentPermission, 'target', entityOptions === null || entityOptions === void 0 ? void 0 : entityOptions.field);
        return source && target;
    };
    BaseFeatureArea.prototype.getSourceOrTarget = function (currentPermission, type, field) {
        var _a, _b, _c, _d, _e;
        var id = currentPermission.id, entity = currentPermission.entity, action = currentPermission.action;
        var actionObj = (_c = (_b = (_a = this.appPermissions) === null || _a === void 0 ? void 0 : _a[id]) === null || _b === void 0 ? void 0 : _b[entity]) === null || _c === void 0 ? void 0 : _c[action];
        var typeValue = currentPermission[type];
        if (typeValue === 'ANY') {
            return actionObj !== undefined;
        }
        var typePermission = (_d = actionObj === null || actionObj === void 0 ? void 0 : actionObj[type]) === null || _d === void 0 ? void 0 : _d[typeValue];
        var wildCardPermission = (_e = actionObj === null || actionObj === void 0 ? void 0 : actionObj[type]) === null || _e === void 0 ? void 0 : _e['*'];
        var typeFieldPermitted = true;
        var wildCardFieldPermitted = true;
        if (field) {
            var typeFields = typePermission === null || typePermission === void 0 ? void 0 : typePermission.fields;
            var wildCardFields = wildCardPermission === null || wildCardPermission === void 0 ? void 0 : wildCardPermission.fields;
            // If fields isn't set then all fields are permitted, otherwise the field must be in the list
            typeFieldPermitted = !typeFields || !!(typeFields === null || typeFields === void 0 ? void 0 : typeFields.includes(field));
            wildCardFieldPermitted = !wildCardFields || !!(wildCardFields === null || wildCardFields === void 0 ? void 0 : wildCardFields.includes(field));
        }
        return ((!!(typePermission === null || typePermission === void 0 ? void 0 : typePermission.enabled) && typeFieldPermitted) ||
            (!!(wildCardPermission === null || wildCardPermission === void 0 ? void 0 : wildCardPermission.enabled) && wildCardFieldPermitted));
    };
    return BaseFeatureArea;
}());
exports.BaseFeatureArea = BaseFeatureArea;
